import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

export const CustomTab = styled(Tab)`
  margin-right: 25px;
`;

export const CustomTabs = styled(Tabs)({
  paddingLeft: "5vw",
  paddingBottom: "10px",
});
